export function random() {
  return Math.floor(Math.random() * 0xffff);
}

export function generateGuid() {
  return (
    Math.random()
      .toString(36)
      .substring(2, 15) +
    Math.random()
      .toString(36)
      .substring(2, 15)
  );
}

export function toUpperLatter(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function toPascalCase(str: string) {
  let arr = str.split('_');
  arr = arr.map(i => toUpperLatter(i.toLocaleLowerCase()));
  return arr.join('');
}

export function isUndefined(value?: string | null | { [key: string]: string }) {
  return typeof value === 'undefined' || value === null || value.length === 0;
}

export function parseSearch(search: string) {
  return search
    .replace(/^\?/, '')
    .split('&')
    .reduce((res: { [key: string]: string }, val: string) => {
      const pair = val.split('=');
      const key = pair[0];
      res[key] = decodeURIComponent(pair[1]);
      return res;
    }, {});
}

export function getFilePath(fileName: string) {
  return `/api/1/download/${fileName}`;
}

export function getFileExtension(name: string) {
  const parts = name.split('.');
  return parts[parts.length - 1];
}

export function isMobile() {
  const { userAgent, platform, maxTouchPoints } = navigator;
  // eslint-disable-next-line max-len
  return (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
      userAgent
    ) ||
    (/MacIntel/.test(platform) && maxTouchPoints && maxTouchPoints > 2)
  );
}

// eslint-disable-next-line consistent-return
export function download(url: string, name: string) {
  const link = document.createElement('a');
  link.href = url;

  if (link.download !== undefined) {
    // Set HTML5 download attribute. This will prevent file from opening if supported.
    const fileName =
      name || url.substring(url.lastIndexOf('/') + 1, url.length);
    link.download = fileName;

    // Dispatching click event.
    if (document.createEvent) {
      const e = document.createEvent('MouseEvents');
      e.initEvent('click', true, true);
      link.dispatchEvent(e);
      return true;
    }

    // Force file download (whether supported by server).
    const query = '?download';

    window.open(url + query, '_self');
  } else {
    document.location.href = url;
  }
}
